var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"w-full xl:w-1/2 bg-teal-300 bg-opacity-90 flex flex-col justify-center items-center text-white space-y-8"},[_c('h2',{staticClass:"text-5xl font-bold tracking-wide"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }